/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`En esta sección aprenderemos como hacer una petición a una API cuando nuestro componente se renderiza.`}</p>
    <p>{`Utilizaremos la `}<a parentName="p" {...{
        "href": "https://pokeapi.co/"
      }}>{`PokeAPI`}</a>{` y la ruta que nos permitirá buscar a nuestros pokémones por nombre o por ID será:`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-unknown"
      }}><code parentName="pre" {...{
          "className": "language-unknown"
        }}>{`https://pokeapi.co/api/v2/pokemon/\${pokemonId}`}</code></pre></div>
    <p>{`Recuerda que debemos cambiar el estado de la Pokédex dependiendo de la respuesta de nuestra API.`}</p>
    <p>{`Todas los frameworks tienen sus propios métodos para implementar este tipo de soluciones, pero aquí decidimos hacerlo así para practicar más conceptos sin instalar ningún paquete adicional.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;